import { Controller, useFormContext } from 'react-hook-form'

import { useQuery } from '@apollo/client'
import { Select } from '@factorialco/f0-react/dist/experimental'
import {
  CurrencySelectorCurrencyFragment,
  GetCurrencySelectorCurrenciesDocument,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'currency'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  currencies?: CurrencySelectorCurrencyFragment[]
  isAutomaticExpensable?: boolean
}

const CurrencyField = ({ currencies, isAutomaticExpensable = false, isFieldReadOnly }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const skip = !!currencies
  const { data } = useQuery(GetCurrencySelectorCurrenciesDocument, { skip })

  const currencyOptions =
    data?.apiCore.currenciesConnection.edges.map((edge) => edge.node) || currencies

  const options =
    currencyOptions?.map((currency) => ({
      label: currency.isoCode,
      value: currency.isoCode,
    })) ?? []

  const isReadOnly = isFieldReadOnly || isAutomaticExpensable

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <Select
          label={i18n.t('expenses_v2.forms.fields.document_currency.label')}
          placeholder={i18n.t('common.select')}
          options={options}
          value={field.value || ''}
          onChange={(value: string) => field.onChange(value)}
          error={castError(errors?.currency)}
          disabled={isReadOnly}
          showSearchBox
          searchBoxPlaceholder={i18n.t('common.search')}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(CurrencyField, FIELD_NAME))
